module.exports = __webpack_public_path__ + "static/media/info-charcoal.b0af30da.svg";